"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressAccrualFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var AddressAccrualFactory = /** @class */ (function (_super) {
    __extends(AddressAccrualFactory, _super);
    function AddressAccrualFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    AddressAccrualFactory.prototype.deploy = function (_claimableToken, overrides) {
        return _super.prototype.deploy.call(this, _claimableToken, overrides || {});
    };
    AddressAccrualFactory.prototype.getDeployTransaction = function (_claimableToken, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _claimableToken, overrides || {});
    };
    AddressAccrualFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    AddressAccrualFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    AddressAccrualFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return AddressAccrualFactory;
}(contracts_1.ContractFactory));
exports.AddressAccrualFactory = AddressAccrualFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_claimableToken",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "_supply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "accrualToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "accruedBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "accruedIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "balances",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "claimFees",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
        ],
        name: "claimFor",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "decreaseShare",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getTotalBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "getUserBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "increaseShare",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "supplyIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "updateFees",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
